module.exports = __webpack_public_path__ + "static/media/kyllinger.f7eb6934.mp3";